import { put, call } from 'redux-saga/effects';
import {logoutSuccess} from "./login-action-creators";
import {redirect} from "../../sagas/redirect-saga";


export function* logoutRequest({ history }) {
  localStorage.token = "";
  yield put(logoutSuccess());
  yield call(redirect, { history, path: "/"})
}


// WEBPACK FOOTER //
// ./src/modules/login/logout-saga.js